import request from '@/utils/request';

export default {
    // 添加企业信息
    async getBook (params) {
        const res = await request.get('/book/' + params.path, { params })
        return res.data
    }
};
